
import { defineComponent } from "vue"
import { useRoute } from "vue-router"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { dispatch } = useStore()
    const { path } = useRoute()

    const showBackButton = path === "/reconn"
    const startVARS = () => dispatch("callgate/startVARS")

    return {
      showBackButton,
      startVARS,
    }
  },
})
